export default __webpack_public_path__ + "static/media/add-circle.c9624ecd.svg";